var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classnames from "classnames";
import _ from "lodash";
import { actions as terminalActions } from "../terminal/terminalActions";
import { isMerchantConfiguredForTerminalNmi, isMerchantConfiguredForTerminalUsaepay } from "../utils/utils";
import { Tooltip as ReactTooltip } from "react-tooltip";
import InputComponent from "../formComponents/input/inputComponent";
import Loader from "../shared/loader/Loader";
import "./terminalModal.scss";
export class TerminalModal extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "handleRegistrationCodeChange", (registrationCode) => {
      this.setState({
        registrationCode
      });
    });
    __publicField(this, "registerTerminal", () => {
      const { registerTerminal, merchantId, settings } = this.props;
      const paymentOptionTag = _.get(settings, "processingOptions.paymentOptionTag", null);
      registerTerminal(this.state.terminalName, merchantId, this.state.registrationCode, paymentOptionTag);
      this.setState({
        timeOut: setTimeout(() => {
          if (this.state.isModalOpen) {
            this.setState({
              registerTerminalTimeout: true
            });
          }
        }, 6e4)
      });
    });
    __publicField(this, "handleOnTerminalConnectionMethodChange", (selected) => {
      if (!_.get(this.props, "isRegisteringTerminal") && !_.get(this.props, "pairingCodeRequestFetching") && !_.get(this.props, "registerTerminalSuccess") && !_.get(this.props, "pairingCode")) {
        this.setState({ terminalConnectionMethod: selected });
      }
    });
    __publicField(this, "terminalNameTooltipMessage", /* @__PURE__ */ jsxs("div", { children: [
      "A terminal nickname to",
      /* @__PURE__ */ jsx("br", {}),
      "differentiate it from",
      /* @__PURE__ */ jsx("br", {}),
      "other terminals configured",
      /* @__PURE__ */ jsx("br", {}),
      "on your account."
    ] }));
    __publicField(this, "tooltip", (id, content) => {
      return /* @__PURE__ */ jsx(
        ReactTooltip,
        {
          id: `${id}`,
          place: "bottom",
          type: "info",
          effect: "float",
          multiline: true,
          children: content
        }
      );
    });
    __publicField(this, "renderTerminalConnectionMethodButtons", () => {
      if (this.state.isConfiguredForNmi && this.state.isConfiguredForUsaepay) {
        const tooltipContent = /* @__PURE__ */ jsxs("div", { children: [
          "Ensure the terminal is powered on",
          /* @__PURE__ */ jsx("br", {}),
          "and connected to the WiFi network.",
          /* @__PURE__ */ jsx("br", {}),
          "Click for troubleshooting"
        ] });
        return /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsxs("div", { className: classnames("terminal-connection-method-label", { initial: this.state.terminalConnectionMethod === "" }), children: [
            "Please check the terminal screen ",
            /* @__PURE__ */ jsx("br", {}),
            " and select one of the following"
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "terminal-connection-method-buttons", children: [
            /* @__PURE__ */ jsxs(
              "div",
              {
                className: classnames("terminal-connection-method-button register", { selected: this.state.terminalConnectionMethod === "register", initial: this.state.terminalConnectionMethod === "" }),
                onClick: () => this.handleOnTerminalConnectionMethodChange("register"),
                children: [
                  "My terminal shows a ",
                  /* @__PURE__ */ jsx("b", { children: "registration" }),
                  " code"
                ]
              }
            ),
            /* @__PURE__ */ jsxs(
              "div",
              {
                className: classnames("terminal-connection-method-button pair", { selected: this.state.terminalConnectionMethod === "pair", initial: this.state.terminalConnectionMethod === "" }),
                onClick: () => this.handleOnTerminalConnectionMethodChange("pair"),
                children: [
                  "My terminal is requesting a ",
                  /* @__PURE__ */ jsx("b", { children: "pairing" }),
                  " code"
                ]
              }
            )
          ] }),
          _.get(this.state, "terminalConnectionMethod") === "" ? /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                className: "cancel-button",
                onClick: this.props.handleClose,
                children: "Close"
              }
            ),
            /* @__PURE__ */ jsxs("a", { "data-tip": true, "data-for": "terminal-connection-method", href: "https://docs.nexiopay.com/docs/overview", target: "_blank", rel: "noreferrer", children: [
              "Need help?",
              this.tooltip("terminal-connection-method", tooltipContent)
            ] })
          ] }) : null
        ] });
      } else {
        return /* @__PURE__ */ jsx(Fragment, {});
      }
    });
    __publicField(this, "renderTerminalConnectionFlow", () => {
      if (this.state.terminalConnectionMethod === "pair") {
        return !this.props.pairingCode ? this.renderFirstStage() : this.renderSecondStage();
      } else if (this.state.terminalConnectionMethod === "register") {
        return this.renderRegistrationFlow();
      } else {
        return null;
      }
    });
    __publicField(this, "renderRegistrationFlow", () => {
      const { terminalName, registrationCode } = this.state;
      const { isRegisteringTerminal, registerTerminalSuccess, handleClose, isTerminalListLoaded } = this.props;
      const submitButtonClasses = classnames({
        "submit-button": true,
        "disabled": !terminalName.length || !registrationCode.length || isRegisteringTerminal || !isTerminalListLoaded
      });
      let buttonLabel = "Submit";
      let modalLabel = "Enter terminal registration info";
      if (registerTerminalSuccess) {
        buttonLabel = "Continue to Payment";
        modalLabel = "Successfully registered terminal";
      }
      return /* @__PURE__ */ jsxs("div", { className: "terminal-name-modal", children: [
        /* @__PURE__ */ jsx("h4", { children: modalLabel }),
        /* @__PURE__ */ jsx(
          InputComponent,
          {
            name: "terminalName",
            label: "Terminal Name",
            tooltip: this.terminalNameTooltipMessage,
            value: terminalName,
            onChange: this.handleTerminalNameChange,
            disabled: registerTerminalSuccess || isRegisteringTerminal
          }
        ),
        /* @__PURE__ */ jsx(
          InputComponent,
          {
            name: "registrationCode",
            label: "Registration Code",
            value: registrationCode,
            disabled: registerTerminalSuccess || isRegisteringTerminal,
            onChange: this.handleRegistrationCodeChange
          }
        ),
        /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            className: "cancel-button",
            onClick: handleClose,
            children: "Close"
          }
        ),
        /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            className: submitButtonClasses,
            disabled: !terminalName.length || !registrationCode.length || isRegisteringTerminal || !isTerminalListLoaded,
            onClick: registerTerminalSuccess ? handleClose : this.registerTerminal,
            children: isRegisteringTerminal || !isTerminalListLoaded ? /* @__PURE__ */ jsx(Loader, {}) : buttonLabel
          }
        )
      ] });
    });
    const isConfiguredForUsaepay = isMerchantConfiguredForTerminalUsaepay(props.merchant);
    const isConfiguredForNmi = isMerchantConfiguredForTerminalNmi(props.merchant);
    this.state = {
      terminalName: "",
      registrationCode: "",
      isConfiguredForNmi,
      isConfiguredForUsaepay,
      terminalConnectionMethod: isConfiguredForNmi ? isConfiguredForUsaepay ? "" : "register" : "pair",
      checkTerminalList: false,
      pairTerminalTimeout: false,
      terminalPaired: false,
      pairingCodeTerminalKey: "",
      isModalOpen: false
    };
    this.handleTerminalNameChange = this.handleTerminalNameChange.bind(this);
    this.fetchPairingCode = this.fetchPairingCode.bind(this);
  }
  handleTerminalNameChange(terminalName) {
    this.setState({
      terminalName
    });
  }
  componentDidMount() {
    this.setState({
      isModalOpen: true
    });
  }
  componentWillUnmount() {
    if (this.state.timeOut) {
      clearTimeout(this.state.timeOut);
    }
    this.setState({
      isModalOpen: false
    });
  }
  componentDidUpdate() {
    if (!this.state.terminalPaired && !this.state.pairTerminalTimeout && _.get(this.props, "pairingCodeTerminalKey") && _.get(this.props, "keepCheckingForNewTerminal")) {
      const pairingCodeTerminalKey = _.get(this.props, "pairingCodeTerminalKey");
      const pairingTerminal = _.find(this.props.terminalList, function(o) {
        return o.terminalKey === pairingCodeTerminalKey;
      });
      if (_.get(pairingTerminal, "terminalStatus") !== "connected") {
        this.props.onCheckTerminals();
      } else if (_.get(pairingTerminal, "terminalStatus") === "connected") {
        this.setState({
          terminalPaired: true
        });
      }
    }
  }
  fetchPairingCode() {
    const { fetchPairingCode, merchantId, settings } = this.props;
    const paymentOptionTag = _.get(settings, "processingOptions.paymentOptionTag", null);
    fetchPairingCode(this.state.terminalName, merchantId, paymentOptionTag);
    this.setState({
      timeOut: setTimeout(() => {
        if (this.state.isModalOpen) {
          this.setState({
            pairTerminalTimeout: true
          });
        }
      }, 6e4)
    });
  }
  renderFirstStage() {
    const { terminalName } = this.state;
    const { pairingCodeRequestFetching, handleClose } = this.props;
    const submitButtonClasses = classnames({
      "submit-button": true,
      "disabled": !terminalName.length || pairingCodeRequestFetching
    });
    return /* @__PURE__ */ jsxs("div", { className: "terminal-name-modal", children: [
      /* @__PURE__ */ jsx("h4", { children: "Enter a terminal name to register" }),
      /* @__PURE__ */ jsx(
        InputComponent,
        {
          name: "terminalName",
          label: "Terminal Name",
          value: terminalName,
          tooltip: this.terminalNameTooltipMessage,
          onChange: this.handleTerminalNameChange
        }
      ),
      /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          className: "cancel-button",
          onClick: handleClose,
          children: "Close"
        }
      ),
      /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          className: submitButtonClasses,
          disabled: !terminalName.length || pairingCodeRequestFetching,
          onClick: this.fetchPairingCode,
          children: pairingCodeRequestFetching ? /* @__PURE__ */ jsx(Loader, {}) : "Submit"
        }
      )
    ] });
  }
  renderSecondStage() {
    const { pairingCode, handleClose } = this.props;
    const { pairTerminalTimeout, terminalPaired } = this.state;
    const submitButtonClasses = classnames({
      "submit-button": true,
      "continue-payment": true,
      waiting: !terminalPaired
    });
    let pairingModalLabel = "Enter pairing code below in your terminal";
    let buttonLabel = "Cancel";
    if (pairTerminalTimeout) {
      pairingModalLabel = "The pairing has timed out.";
      buttonLabel = "Close";
    }
    if (terminalPaired) {
      pairingModalLabel = "Pairing Complete";
      buttonLabel = "Continue to Payment";
    }
    let codeBlock = /* @__PURE__ */ jsx("code", { className: "code-block", children: pairingCode });
    if (terminalPaired) {
      codeBlock = "";
    }
    return /* @__PURE__ */ jsxs("div", { className: "terminal-name-modal", children: [
      /* @__PURE__ */ jsx("h4", { children: pairingModalLabel }),
      codeBlock,
      /* @__PURE__ */ jsxs(
        "button",
        {
          type: "button",
          className: submitButtonClasses,
          onClick: handleClose,
          children: [
            !pairTerminalTimeout && !terminalPaired ? /* @__PURE__ */ jsx(Loader, {}) : "",
            buttonLabel
          ]
        }
      )
    ] });
  }
  render() {
    return /* @__PURE__ */ jsxs("div", { className: "terminal-modal", children: [
      this.renderTerminalConnectionMethodButtons(),
      this.renderTerminalConnectionFlow()
    ] });
  }
}
TerminalModal.propTypes = {
  pairingCodeRequestFetching: PropTypes.bool,
  pairingCode: PropTypes.number,
  pairingCodeTerminalKey: PropTypes.string,
  merchantId: PropTypes.string,
  settings: PropTypes.object,
  fetchPairingCode: PropTypes.func,
  handleClose: PropTypes.func,
  checkTerminalList: PropTypes.bool,
  onCheckTerminals: PropTypes.func,
  terminalList: PropTypes.array,
  merchant: PropTypes.object,
  registerTerminal: PropTypes.func,
  registerTerminalSuccess: PropTypes.bool,
  isRegisteringTerminal: PropTypes.bool,
  isTerminalListLoaded: PropTypes.bool
};
const mapStateToProps = ({ terminal, app, merchant }) => {
  return {
    settings: _.get(app, "settings", {}),
    merchant: _.find(_.get(merchant, "merchantList"), { merchantId: app.merchantId }),
    merchantId: app.merchantId,
    pairingCode: terminal.pairingCode,
    pairingCodeTerminalKey: terminal.pairingCodeTerminalKey,
    pairingCodeRequestFetching: terminal.pairingCodeRequestFetching,
    isRegisteringTerminal: terminal.isRegisteringTerminal,
    registerTerminalSuccess: terminal.registerTerminalSuccess,
    keepCheckingForNewTerminal: terminal.keepCheckingForNewTerminal,
    isTerminalListLoaded: terminal.isTerminalListLoaded,
    terminalList: terminal.terminalList
  };
};
function mapDispatchToProps(dispatch) {
  return {
    fetchPairingCode: (terminalName, merchantId, paymentOptionTag) => dispatch(terminalActions.fetchPairingCode(terminalName, merchantId, paymentOptionTag)),
    registerTerminal: (terminalName, merchantId, registrationCode, paymentOptionTag) => dispatch(terminalActions.registerTerminal(terminalName, merchantId, registrationCode, paymentOptionTag)),
    getTerminals: () => dispatch(terminalActions.getTerminals()),
    onCheckTerminals: _.debounce(() => {
      return dispatch(terminalActions.getTerminals());
    }, 1e3)
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(TerminalModal);
